import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

import { useApi } from '@fortem-monorepo/react-spa'
import { Feeds } from '@fortem-monorepo/web-sdk'

import { toastApiError } from '@/lib/error-toast'
import { useInvalidateScheduledTasks } from '@/react-query/mutations/logs'

export const useInvalidateFeeds = () => {
  const queryClient = useQueryClient()

  return () => {
    queryClient.invalidateQueries({ queryKey: ['feeds'] })
  }
}

export const useRunScheduledTaskMutation = () => {
  const api = useApi()

  const invalidateScheduledTasks = useInvalidateScheduledTasks()

  return useMutation({
    mutationFn: (params: Feeds.RunScheduledTaskParams) => api.feeds.runScheduledTask(params),
    onSuccess(_data, variables) {
      toast.success(`${variables.task_id} started`)
    },
    onError(error, variables) {
      toastApiError(error, `Error starting job ${variables.task_id}`)
    },
    onSettled: () => {
      invalidateScheduledTasks()
    },
  })
}

export const useDeleteProviderTaskDataMutation = () => {
  const api = useApi()

  const invalidateFeeds = useInvalidateFeeds()

  return useMutation({
    mutationFn: (params: Feeds.DeleteScheduledTaskDataParams) => {
      return api.feeds.deleteScheduledTaskData(params)
    },
    onSuccess(_data, params) {
      toast.success(`Deleted data for ${params.table_name} on ${params.value_date}`)
    },
    onError(error, params) {
      toastApiError(error, `Error deleting data for ${params.table_name} on ${params.value_date}`)
    },
    onSettled() {
      invalidateFeeds()
    },
  })
}
